import { WebullPayConnect as WebullConnectComponent } from '../components/WebullPayConnect';

export const WebullPayConnect = () => {
  return <WebullConnectComponent />
}